import {Info} from 'react-feather'

export default [
    {
        id:"helpdesk",
        title:"Informasi & Bantuan",
        icon:<Info size={20}/>,
        navLink:"/helpdesk"
    }
]